import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type {
  ThreeBSliceState,
  ThreeBCreditReportResponse,
  ThreeBSummaryResponse,
} from './types';

const initialState: ThreeBSliceState = {
  report: null,
  summary: null,
  pollingStartedAt: null,
};

const creditReportThreeBSlice = createAppSlice({
  name: 'creditReportThreeB',
  initialState,
  reducers: {
    setThreeBReport(state, action: PayloadAction<ThreeBCreditReportResponse>) {
      state.report = action.payload;
    },
    clearThreeBReport(state) {
      state.report = null;
      state.pollingStartedAt = null;
    },
    setThreeBSummary(state, action: PayloadAction<ThreeBSummaryResponse>) {
      state.summary = action.payload;
    },
    clearThreeBSummary(state) {
      state.summary = null;
    },
    setThreeBPollingStartedAt(state, action: PayloadAction<number>) {
      state.pollingStartedAt = action.payload;
    },
  },
});

export const {
  setThreeBReport,
  clearThreeBReport,
  setThreeBSummary,
  clearThreeBSummary,
  setThreeBPollingStartedAt,
} = creditReportThreeBSlice.actions;

export default creditReportThreeBSlice.reducer;
